import { useGetUserPolicyListQuery } from '@graphql/api';
import ComponentLoading from '@componentsV2/ComponentLoading';
import { ErrorMessage } from '@componentsV2/Typography';
import getUserPolicyListSelector from './getUserPolicyListSelector';
import PolicyListContent from './PolicyListContent';
import { logError, ErrorCode } from '@services/logging';

type Props = {
  userId: string;
  className?: string;
};

const PolicyList: React.FC<Props> = ({ userId, className }) => {
  const {
    isLoading,
    isFetching,
    isError,
    data: userPolicies,
    refetch: refetchUserPolicies,
  } = useGetUserPolicyListQuery(
    { userId },
    {
      queryKey: ['userPolicies', { userId }],
      select: getUserPolicyListSelector,
      useErrorBoundary: false,
      onError: (e: Error) => logError(ErrorCode.UserPolicies, e),
    },
  );

  return (
    <div className={className}>
      {(() => {
        switch (true) {
          case isLoading || isFetching:
            return <ComponentLoading />;
          case isError:
            return <ErrorMessage>Error loading user policies</ErrorMessage>;
          case !userPolicies:
            return <ErrorMessage>User has no policies</ErrorMessage>;
          default:
            return (
              <PolicyListContent
                userId={userId}
                policies={userPolicies!}
                onPolicyChange={refetchUserPolicies}
              />
            );
        }
      })()}
    </div>
  );
};
export default PolicyList;
